import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { routes } from "../../routes";
import UploadMusic from "./UploadMusic/UploadMusic";
import ConvertProfile from "./ConvertProfile/ConvertProfile";
import UploadConfirmation from "./UploadConfirmation/UploadConfirmation";
import PendingApproval from "./PendingApproval/PendingApproval";
import VerifyEmail from "./VerifyEmail/VerifyEmail";
import { useSession } from "../../queries/authentication.query";
import PageLoader from "../../common/components/PageLoader/PageLoader";
import AddEmail from "./AddEmail/AddEmail";

const UploadMusicRoot = () => {
  const router = useRouter();
  const [isUploadSuccess, setIsUploadSuccess] = useState(false);
  const { user, refetch: refreshUserData, isLoading, isFetched } = useSession();

  const onUploadSuccess = async () => {
    await refreshUserData();
    setIsUploadSuccess(true);
  };

  useEffect(() => {
    if (isFetched && !user) {
      router.replace(routes.auth.login);
    }
  }, [user, isFetched]);

  if (isLoading || !user) {
    return <PageLoader instant />;
  }

  if (!user.email) {
    return <AddEmail />;
  }

  if (!user.signed_artist_tc) {
    return <ConvertProfile />;
  }

  if (!user.verified) {
    return <VerifyEmail />;
  }

  if (isUploadSuccess) {
    return (
      <UploadConfirmation
        uploadAnotherTrack={() => setIsUploadSuccess(false)}
      />
    );
  }

  if (user.uploaded_audition_track && !user.approved_artist) {
    return <PendingApproval />;
  }

  return <UploadMusic onUploadSuccess={onUploadSuccess} />;
};

export default UploadMusicRoot;
